"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "travaco-siccomario": {
    "50cc6654": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "skipSearch": false
    }],
    "battella": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4fb39be6": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "skipSearch": false
    }],
    "chiavica": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "travaco-siccomario"
    }],
    "e7489a46": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "skipSearch": false
    }],
    "frua": [{
      "hkey": "c7db52e5",
      "slug": "bettella-chiavica-frua",
      "name": "Bettella-Chiavica-Frua",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "travaco-siccomario"
    }]
  }
};
exports["default"] = _default;